export const Pages = [
    { key: 'BULK_UPLOAD', value: 'Bulk Upload' },
    { key: 'INBOX', value: 'Inbox' },
    { key: 'ACTIVITY_LOG', value: 'Activity Log' },
    { key: 'PAYOR_TYPE', value: 'Payor Type' },
    { key: 'ASSESSMENT_TYPE', value: 'Assessment Type' },
    { key: 'ASSIGNMENT_CONFIGURATION', value: 'Assignment Configuration' },
    { key: 'QA_WEIGHTAGE_CONFIGURATION', value: 'QA Weightage Configuration' },
    { key: 'HOLD_REASON', value: 'Hold Reason' },
    { key: 'TECHNICAL_ISSUE', value: 'Technical Issue' },
    { key: 'SECTION', value: 'Section' },
    { key: 'MITEMS', value: 'Mitem' },
    { key: 'CLIENT', value: 'Client' },
    { key: 'EMPLOYEE_ATTENDANCE', value: 'Employee Attendance' },
    { key: 'GROUP_CONFIGURATION', value: 'Group Configuration' },
    { key: 'REPORTS', value: 'Reports' },
]

export const Permissions = [
    { key: 'read', value: 'Read' },
    { key: 'create', value: 'Create' },
    { key: 'write', value: 'Write' },
    { key: 'delete_', value: 'Delete' },
]
